import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { sendPostRequest } from "./../../APP/HELPERS/requests"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import MainNavs from './../../APP/COMPONENTS/HeaderParts/NavBar/MainNavs';

function mapStateToProps(state) {
    return {
        SHOW_NAVS: state.SHOW_NAVS
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class Navs extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
        this.state = {
        };
        this.OFFSET = 0;
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.SHOW_NAVS !== prevProps.SHOW_NAVS) {
            if (window.innerWidth < 1200) {
                if (!this.props.SHOW_NAVS) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

	render()
    {
        if (this.props.SHOW_NAVS) {
            return (
                <div>
                    <div className="modal-overlay nav-overlay" onClick={() => this.props.showNavs(false)}>
                    </div>
                    <div className="modal-box nav-modal">
                        <MainNavs />
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(Navs);